import PropTypes from 'prop-types';
import React from 'react';
import Breadcrumbs from '../../components/breadcrumbs';
import DesktopHeader from '../../containers/desktop-header';
import SearchInput from '../../containers/search-input';
import BreadcrumbsWidget from '../../containers/breadcrumbs-widget';

const renderSearchInput = () =>
  <SearchInput
    inputClassName="desktop-header-search-text-color desktop-header-search-font"
    borderClassName="desktop-header-search-border-background-color"
    iconClassName="desktop-header-search-icon-fill"
  />;

const InternalPageDesktopHeader = ({ routes, params, ...props }) =>
  <DesktopHeader
    left={<Breadcrumbs routes={routes} params={params}/>}
    right={<BreadcrumbsWidget searchInput={renderSearchInput()}/>}
    {...props}
  />;

InternalPageDesktopHeader.propTypes = {
  routes: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
};

export default InternalPageDesktopHeader;



// WEBPACK FOOTER //
// ./app/containers/internal-page-header/internal-page-desktop-header.js